import { Event } from "../../../events/Event";
import { RenderElement } from "./RenderElement";
export class SubMeshRenderElement extends RenderElement {
    constructor() {
        super();
        this._dynamicWorldPositionNormalNeedUpdate = true;
        this._renderElementOBJ.canDynamicBatch = true;
    }
    _onWorldMatrixChanged() {
        this._dynamicWorldPositionNormalNeedUpdate = true;
    }
    setTransform(transform) {
        if (this.transform !== transform) {
            (this.transform) && (this.transform.off(Event.TRANSFORM_CHANGED, this, this._onWorldMatrixChanged));
            (transform) && (transform.on(Event.TRANSFORM_CHANGED, this, this._onWorldMatrixChanged));
            this._dynamicWorldPositionNormalNeedUpdate = true;
            this.transform = transform;
        }
    }
    setGeometry(geometry) {
        if (this._geometry !== geometry) {
            this._geometry = geometry;
            this._renderElementOBJ.geometry = geometry._geometryElementOBj;
        }
    }
    destroy() {
        if (!this._renderElementOBJ)
            return;
        (this.transform) && this.transform.off(Event.TRANSFORM_CHANGED, this, this._onWorldMatrixChanged);
        super.destroy();
        this.instanceSubMesh = null;
        this.staticBatchElementList && this.staticBatchElementList.destroy();
        this.instanceBatchElementList && this.instanceBatchElementList.destroy();
        this.vertexBatchElementList && this.vertexBatchElementList.destroy();
        this.vertexBatchVertexDeclaration = null;
    }
}
